import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { FlowBehaviours } from './Constants';
var Form = /*#__PURE__*/function (_Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(_args));
    _this.state = {
      validationMap: {},
      step: 0
    };
    _this.handleFlowBehaviour = function () {
      switch (_this.props.flowBehaviour[_this.state.step]) {
        case FlowBehaviours.SUBMIT:
          _this.props.next();
          break;
        case FlowBehaviours.GO_TO_NEXT_STEP:
          _this.setState(function (prevState) {
            return {
              step: prevState.step + 1
            };
          });
          break;
      }
    };
    _this.checkForNumberOfInputs = function () {
      var formInputList = _this.props.layout.steps[_this.state.step].formInputList;
      var formInfo = _this.props.formInfo;
      var _iterator = _createForOfIteratorHelper(formInputList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          _this.props.setFormInfo({
            key: input.id,
            value: formInfo[input.id] ? formInfo[input.id].value : undefined,
            validated: formInfo[input.id] ? formInfo[input.id].validated : false
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    _this._prevTouchHandler = function () {
      _this.props.prev();
    };
    _this._nextTouchHandler = function () {
      var steps = _this.props.layout.steps;
      var formComplete = _this.checkFormComplete();
      if (formComplete && _this.props.flowBehaviour[_this.state.step] && _this.state.step < steps.length - 1) {
        _this.handleFlowBehaviour();
      } else if (formComplete && _this.state.step < steps.length - 1) {
        _this.setState(function (prevState) {
          return {
            step: prevState.step + 1
          };
        });
      } else if (formComplete) {
        _this.props.next();
      }
    };
    _this.checkFormComplete = function () {
      var formInputList = _this.props.layout.steps[_this.state.step].formInputList;
      var formInfo = _this.props.formInfo;
      var _iterator2 = _createForOfIteratorHelper(formInputList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var input = _step2.value;
          if (input.hide) {
            continue;
          }
          if (formInfo[input.id] && !formInfo[input.id].validated) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    };
    _this._getValidation = function (id) {
      var formInfo = _this.props.formInfo;
      for (var _i = 0, _Object$keys = Object.keys(formInfo); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (key === id) {
          return formInfo[key].validated;
        }
      }
      return false;
    };
    /**
     * @memberof Form
     * @params {Object<key, value, validated>} args
     */
    _this._inputChangeHandler = function (args) {
      _this.props.setFormInfo(args);
    };
    _this._layoutChangeHandler = function (changeType) {
      _this.props.emitLayoutChange(changeType);
    };
    return _this;
  }
  _inherits(Form, _Component);
  return _createClass(Form, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearFormInfo();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkForNumberOfInputs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.step !== this.state.step) {
        this.checkForNumberOfInputs();
      }
      if (prevProps.flowBehaviour[this.state.step] !== this.props.flowBehaviour[this.state.step]) {
        this.handleFlowBehaviour();
      }
      if (prevProps.step !== this.props.step) {
        this.setState({
          step: this.props.step
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$layout = this.props.layout,
        header = _this$props$layout.header,
        steps = _this$props$layout.steps;
      var _this$props = this.props,
        customInputStyle = _this$props.customInputStyle,
        customLabelStyle = _this$props.customLabelStyle;
      return this.props.render({
        customInputStyle: customInputStyle,
        customLabelStyle: customLabelStyle,
        header: header,
        steps: steps,
        currentStep: this.props.step || this.state.step,
        status: this.props.serverResponse,
        complete: this.checkFormComplete(),
        nextTouchHandler: this._nextTouchHandler,
        prevTouchHandler: this._prevTouchHandler,
        getValidation: this._getValidation,
        inputChangeHandler: this._inputChangeHandler,
        layoutChangeHandler: this._layoutChangeHandler
      });
    }
  }]);
}(Component);
export { Form as default };
Form.defaultProps = {
  flowBehaviour: {},
  emitLayoutChange: ''
};